<template>
  <FormFieldset
    :label="label"
    :patternLabel="patternLabel"
    :description="description"
    :error="error"
    :errorMessage="errorMessage"
    :req="req"
    :optional="optional"
  >
    <ul class="radioButtons">
      <li v-for="(item, i) in items" :key="i">
        <RadioButton
          :label="item.label"
          :id="item.id"
          :name="name"
          :error="error"
          :value="item.value"
          :req="req"
          :current-value="currentValue"
          @call-input-change="callInputChange"
        />
      </li>
    </ul>
  </FormFieldset>
</template>

<script lang="ts">
import FormFieldset from '@/components/block/FormFieldset.vue'
import RadioButton from '@/components/elements/InputRadioButton.vue'
import { SetupContext } from 'vue'

export default {
  name: 'FormRadioField',

  components: {
    FormFieldset,
    RadioButton
  },

  props: {
    name: String,
    items: Array,
    label: String,
    currentValue: String,
    patternLabel: String,
    req: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
    description: String,
    errorMessage: String,
    error: {
      type: Boolean,
      default: false
    }
  },

  setup(props: any, context: SetupContext) {
    const callInputChange = (value: string) => {
      context.emit('change-value', value)
    }

    return {
      callInputChange
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.radioButtons {
  margin-top: 0;
  display: flex;
  justify-content: space-between;

  @include mixins.media() {
    padding-right: 88px;
  }

  & > li {
    flex-basis: calc(50% - 8px);
  }
}
</style>
